/**
 * Mensaje de un 422 del embudo web EOL (US 23704): Salesforce rechazo el paso y
 * el cliente tiene que corregir un dato antes de seguir.
 */
export const RechazoEmbudo = ({ mensaje }: { mensaje?: string }) =>
    mensaje ? (
        <div className="alert alert-danger fs-14 mb-2" role="alert">
            {mensaje}
        </div>
    ) : null;
